import React from 'react';

import {Text} from 'src/design/atoms/Text';
import {Subtitle} from 'src/design/atoms/Typography';
import {ContentBody} from 'src/app/content-pdf/ContentBody';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {useGetActiveBulletinQuery} from 'src/redux/queries/bulletins';

const GetActiveBulletin: React.FC = () => {
  const {data, isLoading, isFetching} = useGetActiveBulletinQuery(
    {},
    {refetchOnMountOrArgChange: true}
  );

  const showLoader = isLoading || isFetching;
  return !showLoader ? (
    <>
      <Subtitle text={data?.title ?? 'No Current Bulletin'} />
      {data ? (
        <ContentBody
          content={data.content}
          contentPdfUrl={data.contentPdfUrl}
        />
      ) : (
        <Text>Check back later.</Text>
      )}
    </>
  ) : (
    <TableBodyRender isLoading={showLoader} hasData={!!data} />
  );
};

export default GetActiveBulletin;
